import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_jigouyulishi from '../views/lanhu_jigouyulishi/index.vue'
import lanhu_xuekeyukeyan from '../views/lanhu_xuekeyukeyan/index.vue'
import lanhu_zhengwenyexueshuchengguo from '../views/lanhu_zhengwenyexueshuchengguo/index.vue'
import lanhu_shouye from '../views/lanhu_shouye/index.vue'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/lanhu_jigouyulishi"
  },
  {
    path: '/lanhu_jigouyulishi',
    name: 'lanhu_jigouyulishi',
    component: lanhu_jigouyulishi,
    meta: { title: '机构与历史 - 新闻所历史' }
  },
  {
    path: '/lanhu_xuekeyukeyan',
    name: 'lanhu_xuekeyukeyan',
    component: lanhu_xuekeyukeyan,
    meta: { title: '学科与科研 - 新闻所历史' }
  },
  {
    path: '/lanhu_zhengwenyexueshuchengguo',
    name: 'lanhu_zhengwenyexueshuchengguo',
    component: lanhu_zhengwenyexueshuchengguo,
    meta: { title: '学术成果掠影 - 新闻所历史' }
  },
  {
    path: '/lanhu_shouye',
    name: 'lanhu_shouye',
    component: lanhu_shouye,
    meta: { title: '社科网首页 - 新闻所历史' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
